module.exports = __webpack_public_path__ + "static/media/ic-rekening.4254f693.svg";